export type ToastType = "success" | "warning" | "error";

export interface ToastMessage {
  title: string;
  description: string;
  type: ToastType;
  // Optional duration in ms. If set to 0, the toast won’t auto-close.
  duration?: number;
}

export const SHOW_TOAST_EVENT = "microbeta-show-toast";

export const sendToastMessage = (
  title: string,
  description: string,
  type: ToastType,
  duration: number = 5000
) => {
  const event = new CustomEvent(SHOW_TOAST_EVENT, {
    detail: { title, description, type, duration },
  });
  window.dispatchEvent(event);
};
